import {useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import './style.css';
import Logo from 'assets/ActusIcone2025x1024.png';
import SaltPassword from 'services/md5';
import apibasic from 'services/apibasic';
import {Modal} from 'react-bootstrap';
import StoreLinks from 'components/storelinks';

function LoginModal({ isOpen, onRequestClose }) {

    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [sucesso, setSucesso] = useState('');
    const [loading, setLoading] = useState(false);
    const navigete = useNavigate();

    function ProcessaLogin(e) {
        e.preventDefault();

        if (email.length === 0) {
            setSucesso('E');
            return false;
        }

        if (senha.length === 0) {
            setSucesso('E');
            return false;
        }

        setSucesso('');
        setLoading(true);

        apibasic.post('/v1/login', {
            email: email,
            senha: SaltPassword(senha)
        }).then(response => {
            localStorage.setItem('eamigaconfig', JSON.stringify(
                response.data
            ));
            setLoading(false);
            setSucesso('S');
            navigete('/');
        })
            .catch(err => {
                setLoading(false);
                setSucesso('N');
            })
    }

        return <Modal
            show={isOpen}
            onHide={onRequestClose}
            centered
            dialogClassName="login-modal-dialog"
            contentClassName="login-modal-content">
            <Modal.Body className="p-4 pt-5">
                <button type="button" className="btn-close" onClick={onRequestClose} aria-label="Close"></button>
                <div className="login-modal-wrapper">
                    <img className="login-modal-logo" src={Logo} alt="Actus" />
                    <h2 className="login-modal-title mb-1">Seja bem-vindo!</h2>
                    <p className="login-modal-subtitle mb-4 text-muted">Acesse sua conta para aproveitar os benefícios</p>
                    <form className="form-login login-modal-form" onSubmit={(e) => ProcessaLogin(e)}>
                        <div className="input-group-custom mb-3">
                            <label htmlFor="floatinginputemail">E-mail</label>
                            <input type="email" onChange={(e) => setEmail(e.target.value)}
                                className="form-control-custom" id="floatinginputemail" placeholder="Digite seu e-mail" />
                        </div>
                        <div className="input-group-custom mb-1">
                            <label htmlFor="floatinginputpassword">Senha</label>
                            <input type="password" onChange={(e) => setSenha(e.target.value)}
                                className="form-control-custom" id="floatinginputpassword" placeholder="Digite sua senha" />
                        </div>
                        <div className="mb-3 text-danger small text-center min-h-20">
                            {sucesso === 'N' && "E-mail ou senha incorretos"}
                            {sucesso === 'E' && "Por favor, preencha todos os campos"}
                            {sucesso !== 'N' && sucesso !== 'E' && <span>&nbsp;</span>}
                        </div>
                        <button className="btn-login-main w-100 mb-4"
                            disabled={loading}
                            type='submit'>
                            {loading ? (
                                <div className="d-flex align-items-center justify-content-center">
                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                    <span>Entrando...</span>
                                </div>
                            ) : (
                                "Acessar Conta"
                            )}
                        </button>
                        
                        <div className="login-footer-links">
                            <Link to="/solicitaredefinir" onClick={onRequestClose} className="link-secondary">Esqueceu a senha?</Link>
                            <div className="mt-3">
                                <span>Não tem conta? </span>
                                <Link to="/cadastro" onClick={onRequestClose} className="link-highlight">Cadastre-se aqui</Link>
                            </div>
                        </div>
                    </form>

                    <div className="mt-3 pt-2 w-100">
                        <p className="text-muted small mb-3">Baixe também nosso App</p>
                        <StoreLinks className="login-modal-store-links" showTitle={false} />
                    </div>
                </div>
            </Modal.Body>
    </Modal>
}

export default LoginModal;